import { useContext, useState } from 'react'
import PropTypes from 'prop-types'
import { ethers } from 'ethers'
import Button from '@mui/material/Button'
import ConnectMyWallet from '../../components/HeroLookup/ConnectMyAccounts'
import { getProfiles } from '../../services/profile.service'
import { ProfileContext } from '../../context/ProfileContext'
import SearchIcon from '@mui/icons-material/Search'

const ConnectWallet = ({ onConnected }) => {
    const { profile, setProfile } = useContext(ProfileContext)
    const [loaded, setLoaded] = useState(false)

    const handleLoadHeroes = async () => {
        onConnected([profile.id])
        setLoaded(true)
    }

    const handleConnectToWallet = async () => {
        try {
            console.log('connect button clicked')

            // Connect to the Provider
            const provider = window.ethereum == null ? 
                    ethers.getDefaultProvider() : 
                    new ethers.BrowserProvider(window.ethereum)

            if (provider) {
                // Connect to the wallet
                await provider.send('eth_requestAccounts', [])
                const signer = provider.getSigner()
                const address = await signer.getAddress()

                // Load the user's info from DFK
                const _profile = (await getProfiles({ wallets: [address] }))[0]

                // Update the saved profile
                setProfile(_profile)

                onConnected([address])
            } else {
                console.log('no provider registered')
            }
        } catch {
            console.log('failed to get network or wallet address')
        }
    }

    return profile.id ? (
        <div className="connect-my-accounts">
            <Button onClick={handleLoadHeroes}>
                {loaded ? 'Reload' : 'Load'} Heroes From Wallet &nbsp;
                <SearchIcon />
            </Button>
        </div>
    ) : (
        <ConnectMyWallet onConnect={handleConnectToWallet} />
    )
}

ConnectWallet.propTypes = {
    onConnected: PropTypes.func,
}

ConnectWallet.defaultProps = {
    onConnected: () => {},
}

export default ConnectWallet
